import React from 'react';

import {
  Paper,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/PersonOutline';
import BookmarkIcon from '@material-ui/icons/BookmarkBorderOutlined';
import FavoriteIcon from '@material-ui/icons/FavoriteBorderOutlined';
import RequestIcon from '@material-ui/icons/DescriptionOutlined';
import ReplyIcon from '@material-ui/icons/ReplyOutlined';
import StarIcon from '@material-ui/icons/StarBorderOutlined';
import MailIcon from '@material-ui/icons/MailOutline';

import ProfileStatusChange from '../activities/ProfileStatusChange';
import MessageListItem from '../activities/MessageListItem';
import ActivityListItem from '../activities/ActivityListItem';
import classes from '../../../css/getCSS';


const feedItem = (props) => {
  let display = null;
  let icon = null;

  if (props.item.content_type === 'profilestatuschange') {
    display = <ProfileStatusChange {...props.item} />;
    icon = <PersonIcon className={[classes.feedIcon, classes.profileStatusIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'shortlist') {
    display = <ActivityListItem {...props.item} />;
    icon = <BookmarkIcon className={[classes.feedIcon, classes.shortlistsIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'interest') {
    display = <ActivityListItem {...props.item} />;
    icon = <FavoriteIcon className={[classes.feedIcon, classes.interestsIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'request') {
    display = <ActivityListItem {...props.item} />;
    icon = <RequestIcon className={[classes.feedIcon, classes.requestsIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'interestreply' || props.item.content_type === 'requestreply') {
    display = <ActivityListItem {...props.item} />;
    icon = <ReplyIcon className={[classes.feedIcon, classes.replyIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'recommendation') {
    display = <ActivityListItem {...props.item} />;
    icon = <StarIcon className={[classes.feedIcon, classes.recommendationIconFeed].join(' ')} />;
  }

  if (props.item.content_type === 'message') {
    display = <MessageListItem {...props.item} />;
    icon = <MailIcon className={[classes.feedIcon, classes.messagesIconFeed].join(' ')} />;
  }

  const phrase = <span dangerouslySetInnerHTML={{ __html: props.item.phrase }} />;  // eslint-disable-line

  return (
    <Paper className={[classes.card, classes.noPadding, classes.noBorderXS].join(' ')} style={{ marginBottom: '10px' }}>
      <Grid container>
        <Grid item md={1} sm={1} xs={2} className={classes.feedIconWrapper}>
          {icon}
        </Grid>
        <Grid item md={11} sm={11} xs={10} className={classes.feedPhraseWrapper}>
          <Typography variant="body2">{phrase}</Typography>
          <Typography variant="caption">
            {props.item.created_at}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      {display}
    </Paper>
  );
};

export default feedItem;



// WEBPACK FOOTER //
// ./src/dashboard/components/feed/FeedItem.js